import {
    IArchivedTopic,
    IArchivedTopicMessageFeed,
    ISearchResultArchivedTopic,
    ISearchResultTopic,
    ITopic,
    ITopicMessageFeed,
} from '../store/types';
import { SuSyApi } from './susyApi';

import { TopicParticipant, ITopicMessage } from 'susy-common/models';

export const createTopic = async (
    topic: ITopic
): Promise<{ topic: ITopic; messageFeedId: string }> => {
    const { data } = await SuSyApi.post(`/topic`, topic);

    return data;
};

export const getTopicById = async (topicId: string): Promise<ITopic> => {
    const { data } = await SuSyApi.get(`/topic/getTopicById/${topicId}`);

    return data;
};

export const getTopicMessageFeed = async (
    topicId: string
): Promise<ITopicMessageFeed> => {
    const { data } = await SuSyApi.get(`/topic/${topicId}/messageFeed`);

    return data;
};

export const addParticipantsToTopic = async (
    topicId: string,
    participantIds: string[]
): Promise<string> => {
    const { data } = await SuSyApi.post(`/topic/addParticipants`, {
        topicId,
        participants: participantIds,
    });

    return data;
};

export const getTopicsByParticipant = async (): Promise<ITopic[]> => {
    const { data } = await SuSyApi.get(`/topic/getByParticipant`);

    return data;
};

export const getArchivedTopicById = async (
    topicId: string
): Promise<IArchivedTopic> => {
    const { data } = await SuSyApi.get(
        `/topic/getArchivedTopicById/${topicId}`
    );

    return data;
};

export const getArchivedTopicMessageFeed = async (
    topicId: string
): Promise<IArchivedTopicMessageFeed> => {
    const { data } = await SuSyApi.get(`/topic/${topicId}/archivedMessageFeed`);

    return data;
};

export const getArchivedTopicsByParticipant = async (): Promise<
    IArchivedTopic[]
> => {
    const { data } = await SuSyApi.get(`/topic/getArchivedByParticipant`);

    return data;
};

export const addMessageToTopic = async (
    topicId: string,
    message: ITopicMessage
): Promise<ITopicMessageFeed> => {
    const { data } = await SuSyApi.post(`/topic/addMessage`, {
        topicId,
        message,
    });

    return data;
};

export const editParticipants = async (
    topicId: string,
    newParticipants: TopicParticipant[]
): Promise<TopicParticipant[]> => {
    const { data } = await SuSyApi.post(`/topic/editParticipants`, {
        topicId,
        newParticipants,
    });

    return data;
};

export const addTopicWithUnreadMessages = async (
    topicId: string,
    sendNotificationTo: string[]
): Promise<boolean> => {
    const { data } = await SuSyApi.post(`/topic/addTopicWithUnreadMessages`, {
        topicId,
        sendNotificationTo,
    });

    return data;
};

export const removeTopicWithUnreadMessages = async (
    topicId: string
): Promise<string[]> => {
    const { data } = await SuSyApi.post(
        `/topic/removeTopicWithUnreadMessages`,
        {
            topicId,
        }
    );

    return data;
};

export const removeMultipleTopicsWithUnreadMessages = async (
    topicId: string,
    userIds?: string[]
): Promise<string[]> => {
    const { data } = await SuSyApi.post(
        `/topic/removeMultipleTopicsWithUnreadMessages`,
        {
            topicId,
            userIds,
        }
    );

    return data;
};

export const searchTopicsBySearchTerm = async (
    searchTerm: string
): Promise<{
    topics: ISearchResultTopic[];
    archivedTopics: ISearchResultArchivedTopic[];
}> => {
    const { data } = await SuSyApi.post(`/topic/search`, { searchTerm });

    return data;
};
